// extracted by mini-css-extract-plugin
export default {"menuPopover":"styles_menu-popover__GtXTP","rowDanger":"styles_row-danger__ST1j-","rowInactive":"styles_row-inactive__mPFNf"};